import PaymentButton from './payment-button.vue';

export default PaymentButton;
